import React from 'react';
import classNames from 'classnames';

import STYLES from './styles.module.css';

const { optionWrapper, arrow, arrowWrapper, active } = STYLES;

const SortOptionComponent = (props) => {
  const {
    label,
    options,
    isActive,
    onSortChange,
    activeOption,
    activeClass,
  } = props;
  return (
    <div
      onClick={onSortChange}
      className={classNames([
        optionWrapper,
        isActive ? [activeClass, active] : '',
      ])}
    >
      {label}
      {isActive && options && options.length > 1 && (
        <span className={arrowWrapper}>
          <span
            className={classNames(arrow, STYLES[activeOption.icon] || null)}
          ></span>
        </span>
      )}
    </div>
  );
};

SortOptionComponent.propTypes = {};

SortOptionComponent.defaultProps = {};

export default SortOptionComponent;
